import 'normalize.css'
import Vue from 'vue'
import store from '../src/store/index'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

import { Popover } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { Dialog } from 'vant'
import { pageRate } from './utilies/index'

Vue.use(Popover);

Vue.use(Dialog);
require('../src/assets/css/loading/index.css');
require('../src/assets/css/reset.css');
require('../src/assets/css/SourceHanSansCNRegular.css');
require('./mock');
require('../src/assets/js/sha1.min');

import 'lib-flexible/flexible'
import vueBounce from 'vue-bounce'
import vueWeChatTitle from 'vue-wechat-title'
import globalFunction from '../src/utilies/global_function'; //全局函数
import { _get } from "./http"
import { checkBrowser } from "./utilies"

import global_variables from '../src/utilies/domain'

const wx = require('weixin-js-sdk');
Vue.prototype.wx = wx;
Vue.prototype.global_variables = global_variables;


// 扫码请求
let scanUrlArray = ['/mifi/card/lookup', '/weixin/card/lookup_v2', '/weixin/question/eqReplaceMent'];
let scanApi = global_variables.packed_project === 'mifi' ? '/api/v1/app/mifi_sign_info' : '/api/v1/app/sign_info';

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  if (checkBrowser() === 'wechat') {
    if (scanUrlArray.includes(to.path)) {
      _get(scanApi, { url: `${global_variables.authorized_redirect_url}${to.path}` })
        .then(res => {
          if (res.state === 1) {
            wx.config({
              debug: false,
              appId: res.data.appId,
              signature: res.data.sign,
              timestamp: res.data.timestamp,
              nonceStr: res.data.noncestr,
              jsApiList: ["scanQRCode"]
            })
          }
        })
    }
  }

  if ((to.path === '/login' && global_variables.packed_project === 'card')) {
    pageRate()
  }

  const u = navigator.userAgent.toLowerCase();
  if (u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) !== 'micromessenger') return;

  if (to.path !== global.location.pathname) {
    location.assign(to.fullPath);
  }
});

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0

  // 解决ios微信分享bug
  const agent = navigator.userAgent;
  const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (isiOS && to.path !== location.pathname) {
    // 此处不可使用location.replace
    location.assign(to.fullPath)
  } else {
    next()
  }

})


//适配IOS
window.appToken = function (msg) {
  localStorage.setItem("token", msg);
};

Vue.config.productionTip = false;
Vue.use(globalFunction);
Vue.use(vueWeChatTitle);
Vue.use(vueBounce);
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
